import {Component, ChangeDetectionStrategy} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {AlertComponent} from '@app/component/alert/alert.component';
import {MenuComponent} from '@app/component/menu/menu.component';
import {FooterComponent} from '@app/component/footer/footer.component';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.html',
  styleUrls: ['./app.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterOutlet,
    AlertComponent,
    MenuComponent,
    FooterComponent
  ],
})
export class App {
  constructor(
    private readonly title: Title
  ) {
    this.title.setTitle(`OBiServer`);
  }
}
